import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2e2c58af&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=2e2c58af&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=2e2c58af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d599b848f88cdbef2b04a4fd3d36314d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c58af",
  null
  
)

export default component.exports